import AssembleSimModal from './assemble-sim-modal.vue'
export default AssembleSimModal
